import { pageExpansion } from "@/lib/page-expansions";

/**
 * Renders the answer-first expansion block for a page that already ranks just
 * off page one. No-ops when the path has no expansion entry.
 */
export function PageExpansion({ path }: { path: string }) {
  const block = pageExpansion(path);
  if (!block) return null;
  return (
    <section className="glass mt-8 rounded-2xl p-6">
      <h2 className="text-xl font-bold">{block.heading}</h2>
      <p className="aeo-answer mt-2 max-w-3xl text-sm text-muted-foreground leading-relaxed">{block.intro}</p>
      <div className="mt-4 grid gap-4 sm:grid-cols-2">
        {block.items.map((it) => (
          <div key={it.q}>
            <h3 className="text-sm font-semibold">{it.q}</h3>
            <p className="aeo-answer mt-1 text-sm text-muted-foreground leading-relaxed">{it.a}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
